import instance from 'utils/axios/instance.axios';
import { RESEARCH_FIELDS } from './_constant';

export const getAll = () => instance.get(RESEARCH_FIELDS.GET_ALL);

export const getAllResearchFieldsByUserId = () => instance.get(RESEARCH_FIELDS.GET_ALL_BY_USER_ID);

export const getAllForAdministration = () =>
  instance.get(RESEARCH_FIELDS.GET_ALL_FOR_ADMINISTRATION);

export const create = (data = {}) => instance.post(RESEARCH_FIELDS.CREATE, data);

export const update = ({ id, data = {} }) => instance.patch(RESEARCH_FIELDS.UPDATE(id), data);

export const deleteById = (id) => instance.delete(RESEARCH_FIELDS.DELETE(id));

export const restore = (id) => instance.patch(RESEARCH_FIELDS.RESTORE(id));
